export default {"src":"/_next/static/media/Libkin_small.c4e72296.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};